module.exports = __webpack_public_path__ + "static/media/winnerPhone.93631b46.png";